/** Advertising (campaigns, station ads, map pins), admin users and the audit log. */
export default {
  // Shared with other pages (same translations)
  Status: 'Statusi',
  Photo: 'Fotografia',
  Position: 'Pozita',
  'Click on the map': 'Klikoni në hartë',
  'E-mail': 'E-mail',
  On: 'Ndezur',
  Off: 'Fikur',
  Views: 'Shikime',
  Clicks: 'Klikime',
  Statistics: 'Statistikat',
  Priority: 'Prioriteti',
  'Priority (1–20)': 'Prioriteti (1–20)',
  Logo: 'Logoja',
  'None yet': 'Ende asnjë',

  // Campaigns
  "An advertiser's campaign groups its station ads and map pins. Pausing a campaign pauses all of its ads.":
    'Fushata e një reklamuesi grupon reklamat e tij në stacione dhe pinat në hartë. Pezullimi i fushatës pezullon të gjitha reklamat e saj.',
  'New campaign': 'Fushatë e re',
  Contact: 'Kontakti',
  'Daily report': 'Raporti ditor',
  '{n} recipient': '{n} marrës',
  '{n} recipients': '{n} marrës',
  Running: 'Në zhvillim',
  Paused: 'E pezulluar',
  'Advertiser name, phone or e-mail': 'Emri, telefoni apo e-maili i reklamuesit',
  'Report recipients': 'Marrësit e raportit',
  "Receive yesterday's views and clicks every morning at 09:00.":
    'Merrni shikimet dhe klikimet e djeshme çdo mëngjes në ora 09:00.',
  'Send the daily report': 'Dërgo raportin ditor',
  'Running (switching also starts/pauses all ads)':
    'Në zhvillim (ndryshimi nis/pezullon edhe të gjitha reklamat)',
  'Campaigns that still have ads cannot be deleted.': 'Fushatat që kanë ende reklama nuk mund të fshihen.',
  '{views} views · {clicks} clicks': '{views} shikime · {clicks} klikime',

  // Station ads
  '(paused)': '(e pezulluar)',
  'Shown on the station screen in the app. Higher priority ads are shown more often.':
    'Shfaqen në ekranin e stacionit në aplikacion. Reklamat me prioritet më të lartë shfaqen më shpesh.',
  'New ad': 'Reklamë e re',
  Ad: 'Reklama',
  'New station ad': 'Reklamë e re në stacion',
  'Ads without a photo are never shown.': 'Reklamat pa fotografi nuk shfaqen kurrë.',
  'Logo / icon': 'Logoja / ikona',
  'Overlay text': 'Teksti mbi fotografi',
  'Text colour': 'Ngjyra e tekstit',
  Website: 'Uebfaqja',
  'App Store link': 'Linku në App Store',
  'Google Play link': 'Linku në Google Play',
  'An ad with priority 4 is shown four times as often as one with 1.':
    'Një reklamë me prioritet 4 shfaqet katër herë më shpesh se një me prioritet 1.',

  // Map pins
  'Advertiser pins on the app map.': 'Pinat e reklamuesve në hartën e aplikacionit.',
  'Currently switched off in the app API': 'Aktualisht të çaktivizuara në API-në e aplikacionit',
  'New pin': 'Pin i ri',
  Pin: 'Pini',
  'New map pin': 'Pin i ri në hartë',
  'Web page shown when tapped': 'Faqja e uebit që hapet kur prekni',
  'Pin icon (on the map)': 'Ikona e pinit (në hartë)',
  'Background image': 'Fotografia e sfondit',

  // Admin users
  'New admin user': 'Përdorues i ri admin',
  Create: 'Krijo',
  Password: 'Fjalëkalimi',
  'New password (optional)': 'Fjalëkalimi i ri (opsional)',
  Role: 'Roli',
  'Operators manage buses, timetables, news, reports and notifications. Admins can do everything.':
    'Operatorët menaxhojnë busat, oraret, lajmet, raportet dhe njoftimet. Administratorët mund të bëjnë gjithçka.',
  Admin: 'Administrator',
  'Can sign in': 'Mund të kyçet',
  'Delete user?': 'Të fshihet përdoruesi?',
  'They will be signed out immediately.': 'Do të çkyçet menjëherë.',
  'New user': 'Përdorues i ri',
  'No access': 'Pa qasje',
  Disabled: 'I çaktivizuar',

  // Audit log
  'Every change made in the admin panel.': 'Çdo ndryshim i bërë në panelin e administrimit.',
  'Search user or item…': 'Kërko përdoruesin apo elementin…',
  Everything: 'Të gjitha',
  When: 'Kur',
  Who: 'Kush',
  Action: 'Veprimi',
  Item: 'Elementi',
  Changed: 'Ndryshuar',
  File: 'Skedari',
  create: 'krijim',
  update: 'përditësim',
  delete: 'fshirje',
  'sign in': 'kyçje',
  'change password': 'ndryshim i fjalëkalimit',
  reply: 'përgjigje',
  archive: 'arkivim',
  restore: 'rikthim',
  upload: 'ngarkim',
  'assign line': 'caktim i linjës',
  'Mobile app': 'Aplikacioni',
  'Tokens are not checked.': 'Tokenët nuk kontrollohen.',
  Monitor: 'Vëzhgim',
  'Tokens are checked and counted, nothing is blocked. Use this until almost all requests are valid.':
    'Tokenët kontrollohen dhe numërohen, asgjë nuk bllokohet. Përdoreni derisa pothuajse të gjitha kërkesat të jenë të vlefshme.',
  Enforce: 'Detyrim',
  'Requests without a valid token are refused: only the real app can use API v2.':
    'Kërkesat pa token të vlefshëm refuzohen: vetëm aplikacioni i vërtetë mund ta përdorë API v2.',
  'The new app (API v2): who uses it, App Check, and what the app reads when it starts.':
    'Aplikacioni i ri (API v2): kush e përdor, App Check dhe çfarë lexon aplikacioni kur niset.',
  'Last 24 hours': '24 orët e fundit',
  'Old app (v1)': 'Aplikacioni i vjetër (v1)',
  'New app (v2)': 'Aplikacioni i ri (v2)',
  'Valid App Check': 'App Check i vlefshëm',
  'Missing or invalid': 'Mungon ose i pavlefshëm',
  '{missing} missing, {invalid} invalid': '{missing} mungojnë, {invalid} të pavlefshëm',
  'Requests per hour': 'Kërkesa në orë',
  'Installs of the new app': 'Instalimet e aplikacionit të ri',
  'None yet.': 'Ende asnjë.',
  Total: 'Gjithsej',
  'Active (7 days)': 'Aktive (7 ditë)',
  Push: 'Njoftime push',
  'Versions (7 days)': 'Versionet (7 ditë)',
  'Settings the app reads': 'Cilësimet që lexon aplikacioni',
  'Minimum version': 'Versioni minimal',
  'Older versions must update.': 'Versionet më të vjetra duhet të përditësohen.',
  'Latest version': 'Versioni i fundit',
  'Older versions see an update hint.': 'Versionet më të vjetra shohin një sugjerim për përditësim.',
  'Store link': 'Lidhja në dyqan',
  'SMS tickets': 'Biletat me SMS',
  'The SMS is sent to the number with the text. {line} is replaced with the chosen line.':
    'SMS-ja dërgohet në numrin me tekstin. {line} zëvendësohet me linjën e zgjedhur.',
  Number: 'Numri',
  'SMS text': 'Teksti i SMS-së',
  'Choose a line': 'Zgjidh linjën',
  'Add ticket': 'Shto biletë',
  'Passenger demand': 'Kërkesat e udhëtarëve',
  'See all': 'Shiko të gjitha',
  Mon: 'Hën',
  Tue: 'Mar',
  Wed: 'Mër',
  Thu: 'Enj',
  Fri: 'Pre',
  Sat: 'Sht',
  Sun: 'Die',
  'How often and where people ask the app when the bus comes: a station opened or a bus tapped, with the phone’s location.':
    'Sa shpesh dhe ku njerëzit pyesin aplikacionin kur vjen autobusi: një stacion i hapur ose një autobus i shtypur, me vendndodhjen e telefonit.',
  Requests: 'Kërkesa',
  'vs yesterday': 'krahasuar me dje',
  'vs the {n} days before': 'krahasuar me {n} ditët para',
  'Per day': 'Në ditë',
  'Busiest hour': 'Ora më e ngarkuar',
  'Busiest day': 'Dita më e ngarkuar',
  'Where people use the app': 'Ku e përdorin njerëzit aplikacionin',
  'By hour of day': 'Sipas orës së ditës',
  'By day of week': 'Sipas ditës së javës',
  'By day': 'Sipas ditës',
  'Search stations…': 'Kërko stacione…',
  'No requests in this period.': 'Asnjë kërkesë në këtë periudhë.',
  Change: 'Ndryshimi',
  'Lines (buses tapped)': 'Linjat (autobusë të shtypur)',
  'A tapped bus counts for the line it is on now.':
    'Një autobus i shtypur numërohet për linjën ku është tani.',
  Heatmap: 'Harta e nxehtësisë',
  'Requested stations': 'Stacionet e kërkuara',
  '{n} requests in this period': '{n} kërkesa në këtë periudhë',
  'Half of them from within {m} m': 'Gjysma e tyre nga brenda {m} m',
  'The heatmap shows where the people asking about this station were.':
    'Harta tregon ku ishin njerëzit që pyetën për këtë stacion.',
  'Open station': 'Hap stacionin',
  'All passengers': 'Të gjithë udhëtarët',
  'Request locations': 'Vendndodhjet e kërkesave',
  'Dots (about 100 m)': 'Pika (rreth 100 m)',
  'Where the phone was when asking': 'Ku ishte telefoni kur pyeti',
  'Station asked about (bigger: more requests)': 'Stacioni i pyetur (më i madh: më shumë kërkesa)',
  'Phones without a location are left out.': 'Telefonat pa vendndodhje nuk shfaqen.',
  'View only: only administrators can change this.':
    'Vetëm për shikim: vetëm administratorët mund ta ndryshojnë këtë.',
  Issues: 'Probleme',
  'Arrival times': 'Kohët e mbërritjes',
  'From history': 'Nga historiku',
  'How long buses usually take between stations at this time of day, adjusted to how the bus runs today. Where history is missing, the current speed is used.':
    'Sa zgjat zakonisht autobusi mes stacioneve në këtë orë të ditës, i përshtatur me mënyrën si po ecën sot. Ku mungon historiku, përdoret shpejtësia aktuale.',
  'From current speed (old)': 'Nga shpejtësia aktuale (e vjetra)',
  'Distance divided by the bus’s average speed of the last 15 minutes, as before.':
    'Distanca e pjesëtuar me shpejtësinë mesatare të autobusit në 15 minutat e fundit, si më parë.',
  'History updated {time}': 'Historiku u përditësua më {time}',
  '{n} direction': '{n} drejtim',
  '{n} directions': '{n} drejtime',
  '{n} station passing': '{n} kalim në stacion',
  '{n} station passings': '{n} kalime në stacione',
  'History is being built: a few minutes after the update, then every night.':
    'Historiku po ndërtohet: pak minuta pas përditësimit, pastaj çdo natë.',
  'Applies to both apps within a minute; the response format does not change.':
    'Vlen për të dy aplikacionet brenda një minute; formati i përgjigjeve nuk ndryshon.',
} satisfies Record<string, string>;
